import { Action } from "redux";

export const DENSIFY_GEOMETRY_ACTION = "TOGGLE_DENSIFY_GEOMETRY_ACTION";

export interface DensifyGeometryAction extends Action {}

export const densifyGeometryAction = (): DensifyGeometryAction => ({
    type: DENSIFY_GEOMETRY_ACTION,
});
